exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-partials-patientselect-style__newPatient{cursor:pointer}.nil-sa-partials-patientselect-style__newPatientField{margin-bottom:10px}.nil-sa-partials-patientselect-style__newPatientButton{margin-left:10px}.nil-sa-partials-patientselect-style__newPatientButtonContainer{position:relative;text-align:center;margin-top:10px}.nil-sa-partials-patientselect-style__leftArrow{text-align:right}.nil-sa-partials-patientselect-style__leftArrow,.nil-sa-partials-patientselect-style__rightArrow{padding-top:80px;font-size:30px;cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.nil-sa-partials-patientselect-style__rightArrow{text-align:left}.nil-sa-partials-patientselect-style__disabled{opacity:.2;cursor:auto}.nil-sa-partials-patientselect-style__patientSpinner{text-align:center;width:100%;font-size:30px;padding-bottom:40px}", ""]);

// exports
exports.locals = {
	"newPatient": "nil-sa-partials-patientselect-style__newPatient",
	"newPatientField": "nil-sa-partials-patientselect-style__newPatientField",
	"newPatientButton": "nil-sa-partials-patientselect-style__newPatientButton",
	"newPatientButtonContainer": "nil-sa-partials-patientselect-style__newPatientButtonContainer",
	"leftArrow": "nil-sa-partials-patientselect-style__leftArrow",
	"rightArrow": "nil-sa-partials-patientselect-style__rightArrow",
	"disabled": "nil-sa-partials-patientselect-style__disabled",
	"patientSpinner": "nil-sa-partials-patientselect-style__patientSpinner"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/partials/PatientSelect/style.less
// module id = 441
// module chunks = 0